import {
  ModuleCustomChartTotalOverview,
  ModuleCustomChartEnergyRatePie,
  ModuleCustomChartDailyStatistic,
  ModuleCustomChartMonthlyStatistic,
  ModuleCustomChartElectricityList,
} from "./customChart";

export default function BackHome() {
  return (
    <div className="body-main-wrap">
      <div className="grid">
        <div className="col-12">
          <ModuleCustomChartTotalOverview />
        </div>
        <div className="col-12 md:col-6 lg:col-7">
          <ModuleCustomChartDailyStatistic />
        </div>
        <div className="col-12 md:col-6 lg:col-5">
          <ModuleCustomChartEnergyRatePie />
        </div>
        <div className="col-12">
          <ModuleCustomChartMonthlyStatistic />
        </div>
        <div className="col-12">
          <ModuleCustomChartElectricityList />
        </div>
      </div>
    </div>
  );
}
